import { atom } from 'jotai';
import type { CleanupLogFilters } from './types';

export const EMPTY_FILTERS: CleanupLogFilters = {
  entityTypes: [],
  provenance: '',
  after: '',
  before: '',
  search: '',
  page: 1,
  perPage: 50,
};

// Filter + pagination state; the list query in hooks.ts keys off it.
export const cleanupFiltersAtom = atom<CleanupLogFilters>(EMPTY_FILTERS);
